import { BUSINESS_ROLE_GROUPS } from '@/components/security/AppRoles';
import PickUpDetail from '@/pages/Business/pages/PickUp/PickUpDetail';
import PickUp from '@/pages/Business/pages/PickUp/PickUp';
import { ErrorPage } from '@/pages/Layout/pages';
import { RouteObject } from 'react-router-dom';
import { Authorize } from '@/components';

const PickUpRoutes: RouteObject[] = [
  {
    path: 'pickup',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.full}
        fallback={<ErrorPage code={403} />}
      >
        <PickUp />
      </Authorize>
    ),
  },
  {
    path: 'pickup/:id',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.full}
        fallback={<ErrorPage code={403} />}
      >
        <PickUpDetail />
      </Authorize>
    ),
  },
];

export default PickUpRoutes;
